import { FaFacebookF, FaInstagram, FaPinterestP, FaTiktok, FaXTwitter } from 'react-icons/fa6';

export const SOCIALS_CONFIG = [
  {
    name: 'facebook',
    label: 'Facebook',
    bgColor: '#3b5998',
    icon: FaFacebookF,
    prependText: 'https://facebook.com/',
  },
  {
    name: 'instagram',
    label: 'Instagram',
    bgColor: '#E1306C',
    icon: FaInstagram,
    prependText: 'https://instagram.com/',
  },
  {
    name: 'tiktok',
    label: 'TikTok',
    bgColor: '#000000',
    icon: FaTiktok,
    prependText: 'https://tiktok.com/@',
  },
  {
    name: 'x',
    label: 'X',
    bgColor: '#000000',
    icon: FaXTwitter,
    prependText: 'https://x.com/',
  },
  {
    name: 'pinterest',
    label: 'Pinterest',
    bgColor: '#E60023',
    icon: FaPinterestP,
    prependText: 'https://pinterest.com/',
  },
];

export const getSocialPrependText = (socialName) =>
  SOCIALS_CONFIG.find(({ name }) => name === socialName)?.prependText || '';

export const getSocialInputValue = (value, prependText) => {
  const trimmedValue = value?.trim() || '';

  return prependText ? trimmedValue.replace(prependText, '') : trimmedValue;
};

export const buildSocialLink = (value, prependText) => {
  const trimmedValue = value?.trim() || '';

  if (!trimmedValue || !prependText) return trimmedValue;

  const socialValue = prependText.endsWith('@')
    ? trimmedValue.replace(/^@+/, '')
    : trimmedValue.replace(/^\/+/, '');

  return `${prependText}${socialValue}`;
};
